import { render, staticRenderFns } from "./RemoveAddressModal.vue?vue&type=template&id=39370100&scoped=true&"
import script from "./RemoveAddressModal.vue?vue&type=script&lang=ts&"
export * from "./RemoveAddressModal.vue?vue&type=script&lang=ts&"
import style0 from "./RemoveAddressModal.vue?vue&type=style&index=0&id=39370100&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39370100",
  null
  
)

export default component.exports